import { render, staticRenderFns } from "./ProductIconEdit.vue?vue&type=template&id=80c50704&"
import script from "./ProductIconEdit.vue?vue&type=script&lang=js&"
export * from "./ProductIconEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports